import { gql } from '@apollo/client';
import appraiserEventFieldsFragment from './appraiserEventFragment';
import userEventParticipationInfoCalendarViewFragment from './userEventParticipationInfoCalendarViewFragment';

const GET_ATL_CALENDAR = gql`
  query GetATLCalendar($selectedYear: Int!) {
    atlAppraiserEvents(selectedYear: $selectedYear) {
      ...AppraiserEventFields
      TargetUserEventParticipationInfo(targetUserId: null) {
        ...UserEventParticipationInfoFields
      }
    }

    openForATLBidEvents(selectedYear: $selectedYear) {
      Id
      StartDate
      OrgUnitNames
      EventBid {
        BidDate
      }
    }
  }

  ${userEventParticipationInfoCalendarViewFragment}
  ${appraiserEventFieldsFragment}
`;

export default GET_ATL_CALENDAR;
